export default __webpack_public_path__ + "40e64b98423ae7a92732db3a811acf32.jpg";